var React = require('react');

function IconUndo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.78 3.215h9.571a4.65 4.65 0 0 1 0 9.298H1.657v-.93h10.694a3.719 3.719 0 1 0 0-7.439H2.78l2.557 2.557-.658.658L1 3.679 4.68 0l.657.657L2.78 3.215z"}));
}

IconUndo.displayName = "IconUndo";

IconUndo.defaultProps = {"width":"18","height":"14","viewBox":"0 -1 18 15"};

module.exports = IconUndo;

IconUndo.default = IconUndo;
